import { useEffect, useRef } from 'react'

import { getCountryByIP } from '@/models/auth/ports'
import useObjectStorage from './use-objectstorage'

interface UserLocation {
  country_code_alpha2: string
  country_name: string
  state: string
  city: string
  city_confidence: number | null
  loaded?: boolean
  message?: string
}

export const useGeoIpLocation = (): UserLocation => {
  const loadedRef = useRef(false)
  const [userLocation, setUserLocation] = useObjectStorage('userLocationZendesk', {})

  useEffect(() => {
    if (loadedRef.current || userLocation.loaded) return

    const getUserLocation = async () => {
      try {
        const { body } = (await getCountryByIP()) || {}
        await setUserLocation({ ...body, loaded: true })
        loadedRef.current = true
      } catch (error) {
        console.error('Error fetching user location:', error)
      }
    }
    getUserLocation()
  }, [])

  return userLocation
}
